import { Component } from '@angular/core';

@Component({
  selector: 'yosite-logo',
  templateUrl: './logo.component.html',
})
export class LogoComponent { }
